import { useMemo } from "react";
import { useHeroTerrace } from "./useHeroTerrace";
import { useGridType } from "./useGridType";
import { GridTypes } from "../utils/SchoolBlocksUtilities";
import { useStores } from "../stores/useStores";
import { useShowHomepage } from "./useShowHomepage";

export function useHeroMediaItems(): IMediaItem[] {
  const { organizationStore, interfaceStore } = useStores();

  const isWelcomePage = useShowHomepage();
  const heroTerrace = useHeroTerrace();
  const gridType = useGridType();

  const getSeededRandom = (arr) => {
    const num = interfaceStore.stableRequestId % arr.length;
    return arr[num];
  };

  return useMemo(
    () => {
      let customMedia: IMediaItem[] = [],
        mediaRegistry: IMediaItem[] = [];
      if (isWelcomePage) {
        customMedia =
          organizationStore.organization.json_data?.settings?.hero?.filter(
            (media) => media.enabled,
          );
        mediaRegistry = organizationStore.organization.media;
      } else if (gridType === GridTypes.terraced) {
        if (heroTerrace) {
          customMedia = heroTerrace.media.filter((media) => media.enabled);
          mediaRegistry = heroTerrace.media_registry;
        }
      }
      if (customMedia.length > 0) {
        const seededRandom = getSeededRandom(customMedia);

        if (seededRandom.type === "image") {
          // If the chosen media is an image, return all images to be looped through
          return customMedia.filter((m) => m.type === "image");
        } else {
          // Otherwise it's a video, and we should only return one so there's no jarring loop between multiple videos
          return [seededRandom];
        }
      } else {
        return [getSeededRandom(mediaRegistry)];
      }
    },
    isWelcomePage
      ? [
          organizationStore.organization.json_data?.settings?.hero,
          organizationStore.organization.media,
        ]
      : gridType === GridTypes.terraced
        ? [heroTerrace?.media, heroTerrace?.media_registry]
        : [],
  );
}
